import React, { useState } from 'react';
import {
    TextField,
    ReferenceField,
    DateField,
    useResourceContext,
    useDelete,
    useUpdate,
    useNotify,
} from 'react-admin';
import {
    Typography,
    Tooltip,
    IconButton,
    FilledInput,
    Button,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import EditIcon from '@mui/icons-material/Edit';
import TrashIcon from '@mui/icons-material/Delete';
// import UserAvatar from 'admin/users/UserAvatar'
// import { Status } from './Status';

const useStyles = makeStyles(theme => ({
    root: {
        marginBottom: theme.spacing(2),
    },
    metadata: {
        marginBottom: theme.spacing(1),
        color: theme.palette.text.secondary,
    },
    textarea: {
        paddingTop: 16,
        paddingLeft: 14,
        paddingRight: 60,
        paddingBottom: 14,
        lineHeight: 1.3,
    },
    buttons: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: theme.spacing(1),
    },
    cancel: {
        marginRight: theme.spacing(1),
    },
    content: {
        backgroundColor: '#edf3f0',
        padding: '0 1em',
        borderRadius: 10,
        display: 'flex',
        alignItems: 'stretch',
        marginBottom: theme.spacing(1),
    },
    text: {
        flex: 1,
    },
    paragraph: {
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.body1.fontSize,
        lineHeight: 1.3,
        marginBottom: theme.spacing(2.4),
    },
    toolbar: {
        marginLeft: theme.spacing(2),
        visibility: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around',
    },
}));

const Note = ({
    showStatus,
    note,
    isLast,
    reference,
    record
}) => {
    const [isHover, setHover] = useState(false);
    const [isEditing, setEditing] = useState(false);
    const [noteText, setNoteText] = useState(note.text);
    const resource = useResourceContext();
    const notify = useNotify();
    const classes = useStyles();
    const [update, { loading }] = useUpdate();
    const [deleteOne] = useDelete(
        resource,
        { id: note.id, previousRecord: note },
        {
            mutationMode: 'undoable',
            onSuccess: () => {
                notify('Note deleted', { type: 'info', undoable: true });
                update(
                    reference,
                    { id: record.id, data: { nb_notes: record.nb_notes - 1 }}
                );
            },
            onError: (err) => notify(err)
        }
    );

    const handleDelete = () => {
        deleteOne();
    }

    const handleEnterEditMode = () => {
        setNoteText(note.text);
        setEditing(true);
    };

    const handleCancelEdit = () => {
        setEditing(false);
        setNoteText(note.text);
        setHover(false);
    };

    const handleTextChange = (event) => {
        setNoteText(event.target.value);
    };

    const handleNoteUpdate = (event) => {
        event.preventDefault();

        update(resource, { id: note.id, data: { text: noteText } }, {
            onSuccess: () => {
                notify('Note updated succcessfully!');
                setEditing(false);
                setNoteText(note.text);
                setHover(false);
            },
            onError: (err) => notify(`Note update failed: ${err}`)
        });
    };

    return (
            <div
                className={classes.root}
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
            >
                <div className={classes.metadata}>
                    {/* <ReferenceField
                        record={note}
                        resource="contactNotes"
                        source="user_id"
                        reference="profile"
                        basePath="/contactNotes"
                    >
                        <TextField source="first_name" variant="body1" />
                    </ReferenceField> */}
                    <ReferenceField
                            label="Creator"
                            source="user_id"
                            reference="profile"
                            allowEmpty
                            link={false}
                            record={note}
                        >
                            <TextField source="name" />
                        </ReferenceField>
                    {' '}
                    <TextField source="user_id" />
                    <Typography component="span" variant="body1">
                        added a note on{' '}
                    </Typography>
                    <DateField
                        source="date_added"
                        record={note}
                        variant="body1"
                        showTime
                        locales="en-US"
                        options={{
                            dateStyle: 'full',
                            timeStyle: 'short',
                        }}
                        transform = {(value) => {
                            console.log(value)
                            return new Date(value+"Z").toLocaleString()
                        }}
                    />{' '}
                    {/* {showStatus && <Status status={note.status} />} */}
                </div>
                {isEditing ? (
                    <form onSubmit={handleNoteUpdate}>
                        <FilledInput
                            value={noteText}
                            onChange={handleTextChange}
                            fullWidth
                            multiline
                            className={classes.textarea}
                            autoFocus
                        />
                        <div className={classes.buttons}>
                            <Button
                                className={classes.cancel}
                                onClick={handleCancelEdit}
                                color="primary"
                            >
                                Cancel
                            </Button>
                            <Button
                                type="submit"
                                color="primary"
                                variant="contained"
                                disabled={loading}
                            >
                                Update Note
                            </Button>
                        </div>
                    </form>
                ) : (
                    <div className={classes.content}>
                        <div className={classes.text}>
                            {note.text
                                .split('\n')
                                .map((paragraph, index) => (
                                    <p className={classes.paragraph} key={index}>
                                        {paragraph}
                                    </p>
                                ))}
                        </div>
                        <div
                            className={classes.toolbar}
                            style={{ visibility: isHover ? 'visible' : 'hidden' }}
                        >
                            <Tooltip title="Edit note">
                                <IconButton
                                    size="small"
                                    onClick={handleEnterEditMode}
                                >
                                    <EditIcon />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Delete note">
                                <IconButton size="small" onClick={e => handleDelete(e)}>
                                    <TrashIcon />
                                </IconButton>
                            </Tooltip>
                        </div>
                    </div>
                )}
            </div>
    );
};

export { Note };